import fetchPolyfill from 'whatwg-fetch';

export default window.fetch ?
    window.fetch.bind(window) :
    fetchPolyfill;
